import { useNavigate, useLocation } from 'react-router-dom'
import { Select, SelectContent, SelectItem, SelectTrigger } from '@/components/ui/select'
import { accountIcon } from '@/lib/accountIcon'
import type { Account } from '@/types/db'

// Título da tela de extrato que também é um SELETOR: troca de cartão/conta sem
// voltar à lista. Preserva o mês da URL (?m=) ao navegar. Usado em CardStatementPage
// (cartões) e AccountStatementPage (contas).
export function StatementSwitcher({
  current,
  options,
  basePath,
}: {
  current: Account | undefined
  options: Account[]
  basePath: string // '/cartoes' | '/contas'
}) {
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <Select value={current?.id ?? ''} onValueChange={(v) => navigate(`${basePath}/${v}${location.search}`)}>
      <SelectTrigger
        aria-label={current?.name}
        className="hover:bg-accent/40 h-auto w-auto cursor-pointer gap-2 rounded-md border-0 bg-transparent px-1 py-0.5 text-2xl font-semibold tracking-tight shadow-none focus:ring-0 focus-visible:ring-0 [&>svg]:size-5 [&>svg]:opacity-60"
      >
        <span className="inline-flex items-center gap-2">
          {current ? (
            <>
              {accountIcon(current)} {current.name}
            </>
          ) : (
            '—'
          )}
        </span>
      </SelectTrigger>
      <SelectContent position="popper" align="start" className="max-h-80">
        {options.map((a) => (
          <SelectItem key={a.id} value={a.id}>
            {accountIcon(a)} {a.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
